import { IntegrationConfigName } from '../../integrations/integrations.types';
import { StatusType, SynchronizedType } from '../order.types';
import { ForceSyncOrderStatusValidator } from './validators/force-sync';

const REVERSE_SYNC_ALLOWED_SYNC_STATUS = [
  SynchronizedType.SUCCESS,
  SynchronizedType.SUCCESS_WITH_PAYMENT_ERROR,
];

interface ForceSyncVisibilityParams {
  isAdminBrand: boolean;
  hasOrderIntegration: boolean;
  integrationName?: IntegrationConfigName;
}

export interface CanForceSyncOrderParams extends ForceSyncVisibilityParams {
  orderStatus?: StatusType;
  orderStatusSync?: SynchronizedType;
  triggerIntegrationConfig?: StatusType;
}

export interface CanForceReverseSyncOrderParams extends ForceSyncVisibilityParams {
  canForceReverseOrderSync: boolean;
  orderStatusSync?: SynchronizedType;
}

const canSeeForceSyncActions = ({
  isAdminBrand,
  hasOrderIntegration,
  integrationName,
}: ForceSyncVisibilityParams) =>
  isAdminBrand &&
  hasOrderIntegration &&
  integrationName !== IntegrationConfigName.TECEO_BRAND_INTEGRATOR;

export const canForceSyncOrder = ({
  isAdminBrand,
  integrationName,
  hasOrderIntegration,
  orderStatus,
  orderStatusSync,
  triggerIntegrationConfig,
}: CanForceSyncOrderParams) => {
  if (!canSeeForceSyncActions({ isAdminBrand, hasOrderIntegration, integrationName })) {
    return false;
  }

  return ForceSyncOrderStatusValidator.showForceSync({
    orderStatus,
    orderStatusSync,
    integrationName,
    triggerIntegrationConfig,
  });
};

export const canForceReverseSyncOrder = ({
  isAdminBrand,
  integrationName,
  hasOrderIntegration,
  canForceReverseOrderSync,
  orderStatusSync,
}: CanForceReverseSyncOrderParams) => {
  if (
    !canSeeForceSyncActions({ isAdminBrand, hasOrderIntegration, integrationName }) ||
    !canForceReverseOrderSync
  ) {
    return false;
  }

  return !!orderStatusSync && REVERSE_SYNC_ALLOWED_SYNC_STATUS.includes(orderStatusSync);
};
